import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import styles from './time-picker.module.scss';
import { TimePickerItem } from '.';
import { Icon } from '../icon';

type TimePickerFlyoutProps = {
  items: TimePickerItem[];
  id: string;
  value: string;
  open: boolean;
  activeOption?: number;
  closeFlyoutClick: () => void;
};

export const TimePickerFlyout: React.FC<TimePickerFlyoutProps> = ({
  items,
  id,
  value,
  open,
  activeOption,
  closeFlyoutClick
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (!open) {
      return;
    }

    const el = ref.current;

    el.scrollTop = 0;
  });

  return (
    <div aria-hidden={!open} className={styles.flyout} id={`${id}-listbox`} role="listbox" tabIndex={-1} ref={ref}>
      {items.map((item, i) => (
        <button
          id={`${id}-option-${i}`}
          className={classnames(styles.item, { [styles.activeDescendant]: activeOption === i })}
          key={id + i}
          role="option"
          aria-selected={value === item.value}
          tabIndex={-1}
          onClick={() => {
            closeFlyoutClick();
            item.onClick();
          }}
        >
          {item.value}
          {value === item.value && <Icon name="status-good--small" />}
        </button>
      ))}
    </div>
  );
};
